(() => {
    "use strict";

    function prefersReducedMotion() {
        return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    }

    function isCompactCarousel() {
        return window.matchMedia("(max-width: 1024px)").matches || prefersReducedMotion();
    }

    function pauseFrame(iframe) {
        window.sitePauseYoutubeIframe?.(iframe);
    }

    function initTabs(root) {
        if (root.dataset.bound === "true") {
            return;
        }
        root.dataset.bound = "true";

        const tabs = [...root.querySelectorAll("[data-experiencias-tab]")];
        const host = root.closest(".experiencias-site");
        const panels = [...(host?.querySelectorAll("[data-experiencias-panel]") || [])];
        if (!tabs.length || !panels.length) {
            return;
        }

        tabs.forEach((tab) => {
            tab.addEventListener("click", () => {
                const target = tab.getAttribute("data-experiencias-tab");
                tabs.forEach((entry) => {
                    const active = entry === tab;
                    entry.classList.toggle("is-active", active);
                    entry.setAttribute("aria-selected", active ? "true" : "false");
                });
                panels.forEach((panel) => {
                    const active = panel.getAttribute("data-experiencias-panel") === target;
                    panel.classList.toggle("is-active", active);
                    panel.hidden = !active;
                    if (!active) {
                        const lightbox = panel.querySelector("[data-experiencias-lightbox]");
                        if (lightbox?.open) {
                            lightbox.close();
                        }
                        const testimonialLightbox = panel.querySelector("[data-experiencias-testimonial-lightbox]");
                        if (testimonialLightbox?.open) {
                            testimonialLightbox.close();
                        }
                    }
                });
            });
        });
    }

    function bindPosterFallback(root) {
        root.querySelectorAll("img[data-poster-fallback]").forEach((poster) => {
            const fallback = poster.getAttribute("data-poster-fallback") || "";
            if (fallback === "") {
                return;
            }
            poster.addEventListener("error", () => {
                poster.removeAttribute("data-poster-fallback");
                poster.src = fallback;
            }, { once: true });
        });
    }

    function initTestimonials(root, options = {}) {
        const panel = root.closest("[data-experiencias-panel]");
        const dialog = panel?.querySelector("[data-experiencias-testimonial-lightbox]");
        const cards = [...root.querySelectorAll("[data-experiencias-testimonial]")];
        if (!dialog || typeof dialog.showModal !== "function" || !cards.length) {
            return;
        }

        const closeBtn = dialog.querySelector("[data-experiencias-testimonial-close]");
        const prevBtn = dialog.querySelector("[data-experiencias-testimonial-prev]");
        const nextBtn = dialog.querySelector("[data-experiencias-testimonial-next]");
        const media = dialog.querySelector("[data-experiencias-testimonial-media]");
        const kicker = dialog.querySelector("[data-experiencias-testimonial-kicker]");
        const title = dialog.querySelector("[data-experiencias-testimonial-title]");
        const text = dialog.querySelector("[data-experiencias-testimonial-text]");
        const name = dialog.querySelector("[data-experiencias-testimonial-name]");
        const role = dialog.querySelector("[data-experiencias-testimonial-role]");
        let lastTrigger = null;
        let currentIndex = Math.max(0, cards.findIndex((card) => card.classList.contains("is-active")));

        const stopVideo = () => {
            const iframe = media?.querySelector("iframe");
            if (iframe) {
                pauseFrame(iframe);
            }
            media?.replaceChildren();
            if (media) {
                media.hidden = true;
            }
        };

        const close = () => {
            stopVideo();
            if (dialog.open) {
                dialog.close();
            }
        };

        const setText = (node, value) => {
            if (node) {
                node.textContent = value || "";
            }
        };

        const render = (nextIndex, trigger) => {
            const max = cards.length - 1;
            currentIndex = Math.max(0, Math.min(max, nextIndex));
            const card = cards[currentIndex];
            if (!card) {
                return;
            }

            const embed = card.getAttribute("data-embed") || "";
            const kind = card.getAttribute("data-testimonial-kind") || "texto";
            const label = card.getAttribute("data-testimonial-label") || "";
            const quote = card.getAttribute("data-testimonial-text") || "";

            stopVideo();
            lastTrigger = trigger || card;
            options.goToIndex?.(currentIndex);
            dialog.classList.toggle("is-video", kind === "video" && embed !== "");
            setText(kicker, label);
            setText(title, card.getAttribute("data-testimonial-title"));
            setText(name, card.getAttribute("data-testimonial-name"));
            setText(text, quote);

            if (role) {
                const value = card.getAttribute("data-testimonial-role") || "";
                role.hidden = value === "";
                role.textContent = value;
            }
            if (text) {
                text.hidden = quote === "";
            }
            if (kind === "video" && embed !== "" && media) {
                const separator = embed.includes("?") ? "&" : "?";
                const iframe = document.createElement("iframe");
                iframe.src = `${embed}${separator}autoplay=1&rel=0&enablejsapi=1`;
                iframe.title = card.getAttribute("data-testimonial-name") || "Depoimento";
                iframe.setAttribute(
                    "allow",
                    "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                );
                iframe.setAttribute("referrerpolicy", "strict-origin-when-cross-origin");
                iframe.allowFullscreen = true;
                media.append(iframe);
                media.hidden = false;
            }
            if (prevBtn) {
                prevBtn.disabled = currentIndex <= 0;
            }
            if (nextBtn) {
                nextBtn.disabled = currentIndex >= max;
            }

            if (!dialog.open) {
                dialog.showModal();
            }
        };

        const open = (card, trigger) => {
            if (!card.classList.contains("is-active")) {
                return;
            }
            render(cards.indexOf(card), trigger);
        };

        const showRelative = (delta) => {
            const target = currentIndex + delta;
            if (target < 0 || target >= cards.length) {
                return;
            }
            render(target, cards[target]);
        };

        cards.forEach((card) => {
            const play = card.querySelector("[data-experiencias-video-play]");
            card.addEventListener("click", (event) => {
                if (root.dataset.swiped === "true") {
                    return;
                }
                open(card, event.target.closest("[data-experiencias-video-play]") || card);
            });
            card.addEventListener("keydown", (event) => {
                if (event.key !== "Enter" && event.key !== " ") {
                    return;
                }
                event.preventDefault();
                open(card, card);
            });
            play?.addEventListener("click", (event) => {
                event.preventDefault();
                event.stopPropagation();
                open(card, play);
            });
        });

        closeBtn?.addEventListener("click", close);
        prevBtn?.addEventListener("click", () => showRelative(-1));
        nextBtn?.addEventListener("click", () => showRelative(1));
        dialog.addEventListener("click", (event) => {
            if (event.target === dialog) {
                close();
            }
        });
        dialog.addEventListener("close", () => {
            stopVideo();
            lastTrigger?.focus();
        });
        dialog.addEventListener("keydown", (event) => {
            if (event.key === "ArrowLeft") {
                event.preventDefault();
                event.stopPropagation();
                showRelative(-1);
            }
            if (event.key === "ArrowRight") {
                event.preventDefault();
                event.stopPropagation();
                showRelative(1);
            }
        });
    }

    function initCarousel(root) {
        if (root.dataset.bound === "true") {
            return;
        }
        root.dataset.bound = "true";

        const track = root.querySelector(".experiencias-site-track");
        const viewport = root.querySelector(".experiencias-site-viewport");
        const cards = [...(track?.querySelectorAll(".experiencias-site-card") || [])];
        const prev = root.querySelector("[data-experiencias-prev]");
        const next = root.querySelector("[data-experiencias-next]");
        const dots = [...root.querySelectorAll("[data-experiencias-dot]")];
        if (!track || !cards.length) {
            return;
        }

        let index = Math.max(0, cards.findIndex((card) => card.classList.contains("is-active")));
        let startX = 0;

        const apply = (nextIndex) => {
            const max = cards.length - 1;
            index = Math.max(0, Math.min(max, nextIndex));
            const compact = isCompactCarousel();
            const shift = compact ? 0 : 19.2;
            const sideScale = compact ? 1 : 0.82;

            cards.forEach((card, cardIndex) => {
                const offset = cardIndex - index;
                const abs = Math.abs(offset);
                const active = offset === 0;
                const side = !compact && abs === 1;
                const far = compact ? !active : abs > 1;

                card.classList.toggle("is-active", active);
                card.classList.toggle("is-side", side);
                card.classList.toggle("is-far", far);
                card.style.setProperty("--experiencias-x", `${offset * shift}rem`);
                card.style.setProperty("--experiencias-scale", active ? "1" : String(sideScale));
                card.setAttribute("aria-hidden", active ? "false" : "true");
                card.inert = !active;
                card.tabIndex = active ? 0 : -1;

                if (!active) {
                    card.classList.remove("is-playing");
                }
            });

            dots.forEach((dot, dotIndex) => {
                const active = dotIndex === index;
                dot.classList.toggle("is-active", active);
                dot.setAttribute("aria-selected", active ? "true" : "false");
            });
            if (prev) {
                prev.disabled = index <= 0;
            }
            if (next) {
                next.disabled = index >= max;
            }
        };

        bindPosterFallback(root);
        initTestimonials(root, { goToIndex: apply });

        prev?.addEventListener("click", () => apply(index - 1));
        next?.addEventListener("click", () => apply(index + 1));
        dots.forEach((dot, dotIndex) => {
            dot.addEventListener("click", () => apply(dotIndex));
        });

        viewport?.addEventListener("pointerdown", (event) => {
            if (event.target.closest(".experiencias-site-nav-btn, .experiencias-site-card-play")) {
                return;
            }
            startX = event.clientX;
        });
        viewport?.addEventListener("pointerup", (event) => {
            if (event.target.closest(".experiencias-site-nav-btn, .experiencias-site-card-play")) {
                return;
            }
            const delta = event.clientX - startX;
            if (Math.abs(delta) < 48) {
                return;
            }
            root.dataset.swiped = "true";
            window.setTimeout(() => {
                delete root.dataset.swiped;
            }, 0);
            apply(delta > 0 ? index - 1 : index + 1);
        });

        root.addEventListener("keydown", (event) => {
            if (event.key === "ArrowLeft") {
                event.preventDefault();
                apply(index - 1);
            }
            if (event.key === "ArrowRight") {
                event.preventDefault();
                apply(index + 1);
            }
        });
        root.setAttribute("tabindex", "0");

        window.addEventListener("resize", () => apply(index));
        apply(index);
    }

    function parseAlbums(node) {
        if (!node) {
            return null;
        }
        try {
            return JSON.parse(node.textContent || "{}");
        } catch {
            return null;
        }
    }

    function photosFor(payload, albumIndex) {
        if (!payload) {
            return [];
        }
        if (payload.mode === "albums") {
            return payload.albums?.[albumIndex]?.fotos || [];
        }
        return payload.fotos || [];
    }

    function albumMeta(payload, albumIndex, photo) {
        if (payload?.mode === "albums") {
            const album = payload.albums?.[albumIndex] || {};
            return {
                titulo: album.titulo || photo?.titulo || "",
                kicker: album.titulo || photo?.titulo || "",
                descricao: album.descricao || photo?.descricao || "",
                data: album.data || photo?.data || "",
                local: album.local || photo?.local || "",
            };
        }
        return {
            titulo: photo?.titulo || "",
            kicker: photo?.titulo || "",
            descricao: photo?.descricao || "",
            data: photo?.data || "",
            local: photo?.local || "",
        };
    }

    function padCount(index, total) {
        const size = Math.max(2, String(total).length);
        return `${String(index).padStart(size, "0")} / ${String(total).padStart(size, "0")}`;
    }

    function prefetch(url) {
        if (!url) {
            return;
        }
        const image = new Image();
        image.decoding = "async";
        image.src = url;
    }

    function initGallery(root) {
        if (root.dataset.bound === "true") {
            return;
        }
        root.dataset.bound = "true";

        const payload = parseAlbums(root.querySelector("[data-experiencias-albums]"));
        const dialog = root.querySelector("[data-experiencias-lightbox]");
        const shots = [...root.querySelectorAll("[data-experiencias-shot]")];
        if (!payload || !dialog || typeof dialog.showModal !== "function" || !shots.length) {
            return;
        }

        const image = dialog.querySelector("[data-experiencias-lightbox-image]");
        const count = dialog.querySelector("[data-experiencias-lightbox-count]");
        const kicker = dialog.querySelector("[data-experiencias-lightbox-kicker]");
        const title = dialog.querySelector("[data-experiencias-lightbox-title]");
        const desc = dialog.querySelector("[data-experiencias-lightbox-desc]");
        const dateRow = dialog.querySelector("[data-experiencias-lightbox-date]");
        const placeRow = dialog.querySelector("[data-experiencias-lightbox-place]");
        const thumbs = dialog.querySelector("[data-experiencias-lightbox-thumbs]");
        const prev = dialog.querySelector("[data-experiencias-lightbox-prev]");
        const next = dialog.querySelector("[data-experiencias-lightbox-next]");
        const closeBtn = dialog.querySelector("[data-experiencias-lightbox-close]");
        const thumbLimit = 4;

        let photos = [];
        let albumIndex = 0;
        let index = 0;
        let lastTrigger = null;

        const setText = (node, value) => {
            if (!node) {
                return;
            }
            const target = node.matches("span, p, h3") ? node : node.querySelector("span");
            if (target) {
                target.textContent = value;
            }
        };

        const renderThumbs = () => {
            if (!thumbs) {
                return;
            }
            thumbs.replaceChildren();
            const visible = photos.slice(0, thumbLimit);
            visible.forEach((photo, thumbIndex) => {
                const button = document.createElement("button");
                button.type = "button";
                button.className = "experiencias-site-lightbox-thumb";
                if (thumbIndex === index || (index >= thumbLimit && thumbIndex === visible.length - 1)) {
                    button.classList.add("is-active");
                }
                const remaining = photos.length - thumbLimit;
                if (thumbIndex === thumbLimit - 1 && remaining > 0) {
                    button.classList.add("is-more");
                    button.dataset.more = `+${remaining}`;
                }
                const thumb = document.createElement("img");
                thumb.src = photo.thumb || photo.full;
                thumb.alt = "";
                thumb.loading = "lazy";
                thumb.decoding = "async";
                button.append(thumb);
                button.addEventListener("click", () => show(thumbIndex));
                thumbs.append(button);
            });
        };

        const show = (nextIndex) => {
            if (!photos.length || !image) {
                return;
            }
            const max = photos.length - 1;
            index = Math.max(0, Math.min(max, nextIndex));
            const photo = photos[index];
            const meta = albumMeta(payload, albumIndex, photo);
            image.src = photo.full || photo.thumb || "";
            image.alt = photo.alt || meta.titulo || "";
            if (count) {
                count.textContent = padCount(index + 1, photos.length);
            }
            setText(kicker, meta.kicker);
            if (title) {
                title.textContent = meta.titulo;
            }
            if (desc) {
                const hasDesc = meta.descricao !== "";
                desc.hidden = !hasDesc;
                desc.textContent = meta.descricao;
            }
            if (dateRow) {
                dateRow.hidden = meta.data === "";
                setText(dateRow, meta.data);
            }
            if (placeRow) {
                placeRow.hidden = meta.local === "";
                setText(placeRow, meta.local);
            }
            if (prev) {
                prev.disabled = index <= 0;
            }
            if (next) {
                next.disabled = index >= max;
            }
            renderThumbs();
            prefetch(photos[index + 1]?.full);
            prefetch(photos[index - 1]?.full);
        };

        const open = (nextAlbum, nextPhoto) => {
            albumIndex = nextAlbum;
            photos = photosFor(payload, albumIndex);
            if (!photos.length) {
                return;
            }
            show(nextPhoto);
            if (!dialog.open) {
                dialog.showModal();
            }
        };

        const close = () => {
            if (dialog.open) {
                dialog.close();
            }
        };

        shots.forEach((shot) => {
            shot.addEventListener("click", () => {
                lastTrigger = shot;
                open(
                    Number(shot.getAttribute("data-album-index") || "0"),
                    Number(shot.getAttribute("data-photo-index") || "0")
                );
            });
        });

        prev?.addEventListener("click", () => show(index - 1));
        next?.addEventListener("click", () => show(index + 1));
        closeBtn?.addEventListener("click", close);
        dialog.addEventListener("click", (event) => {
            if (event.target === dialog) {
                close();
            }
        });
        dialog.addEventListener("close", () => {
            lastTrigger?.focus();
        });
        dialog.addEventListener("keydown", (event) => {
            if (event.key === "ArrowLeft") {
                event.preventDefault();
                show(index - 1);
            }
            if (event.key === "ArrowRight") {
                event.preventDefault();
                show(index + 1);
            }
        });
    }

    function boot() {
        document.querySelectorAll("[data-experiencias-tabs]").forEach(initTabs);
        document.querySelectorAll("[data-experiencias-carousel]").forEach(initCarousel);
        document.querySelectorAll("[data-experiencias-gallery]").forEach(initGallery);
    }

    window.siteReady(boot);
})();
